import { gql } from '@apollo/client'

export const CANCEL_BOOKING_TRIP_CHANGE_PROPOSAL = gql`
  mutation CancelBookingTripChangeProposal($bookingId: ID!, $tripChangeProposalId: ID!) {
    cancelBookingTripChangeProposal(input: { id: $bookingId, tripChangeProposalID: $tripChangeProposalId })
  }
`

export const CONFIRM_BOOKING_TRIP_CHANGE_PROPOSAL = gql`
  mutation ConfirmBookingTripChangeProposal($bookingId: ID!, $tripChangeProposalId: ID!) {
    confirmBookingTripChangeProposal(input: { id: $bookingId, tripChangeProposalID: $tripChangeProposalId })
  }
`

export const CREATE_BOOKING_TRIP_CHANGE_PROPOSAL = gql`
  mutation CreateBookingTripChangeProposal($input: CreateBookingTripChangeProposalInput!) {
    createBookingTripChangeProposal(input: $input) {
      id
      trips {
        id
        segment {
          id
          origin {
            id
            name
            city {
              timezone
            }
          }
          destination {
            id
            name
          }
          departureAt
        }
      }
      tickets {
        id
        tripID
        subtotal
        vat
        discount
        passenger {
          id
          firstName
          lastName
        }
        seat {
          id
          label
        }
        ancillaries {
          id
          type
          quantity
          unitPrice
          total
        }
        serviceFee {
          price
        }
      }
      coupon {
        id
        code
        value
        discountType
      }
      reward {
        ticketID
        discount
      }
    }
  }
`

export const CHANGE_BOOKING_ANCILLARIES = gql`
  mutation ChangeBookingAncillaries($input: ChangeBookingTicketsAncillariesInput!) {
    changeBookingTicketsAncillaries(input: $input)
  }
`

export const CANCEL_TICKETS = gql`
  mutation CancelTickets($input: cancelTicketsInput!) {
    cancelTickets(input: $input)
  }
`
export const CANCEL_TICKETS_V2 = gql`
  mutation CancelBookingTickets($input: CancelBookingTicketsInput!) {
    cancelBookingTickets(input: $input)
  }
`
export const UPDATE_BOOKING_STATUS = gql`
  mutation UpdateBookingStatus($status: String!, $bookingId: ID!) {
    updateBookingStatus(status: $status, bookingId: $bookingId) @client
  }
`

export const ADD_REFUNDS_TO_BOOKING = gql`
  mutation AddrefundsToBooking($bookingId: ID!, $refunds: Refunds!) {
    addRefundsToBooking(bookingId: $bookingId, refunds: $refunds) @client
  }
`

export const UPDATE_TICKET_STATUS = gql`
  mutation UpdateTicketStatus($status: String!, $ticketId: ID!) {
    updateTicketStatus(status: $status, ticketId: $ticketId) @client
  }
`

export const REGISTER_BOOKING_TAX_INVOICED = gql`
  mutation RegisterBookingTaxInvoiced($input: RegisterBookingTaxInvoicedInput!) {
    registerBookingTaxInvoiced(input: $input)
  }
`
